import React from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap'
import {Link} from "react-router-dom"

function LoginEffettuato() {

    return (

        <Container fluid>

            {/* SEZIONE BANNER */}
            <Container fluid id="banner_recovered" className="head-banner text-center text-white">
            <Container>
            <Row>
                <Col>
                    <h1><strong>8-Bit Motors</strong></h1>
                </Col>
            </Row>
        </Container>
    </Container>

        <Container className="text-center mt-5">
            <svg xmlns="http://www.w3.org/2000/svg" /* style="width: 6rem; height: 6rem" */ fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
              </svg>
              <h2 class="mt-3"><strong>Login effettuato con successo!</strong></h2>
              <h3 class="mt-3">Bentornato e buona navigazione!</h3>
              <Button variant="dark" className="mt-2"><Link to={"/"} className="link text-white">Conferma</Link></Button>
            </Container>

    

        <br /><br /><br /><br /><br /><br /><br />
        </Container>
    )
}

export default LoginEffettuato
